import AuthService from "../../base/services/authentication.service";

// What the Help Center remembers between visits: article votes. These are
// conveniences for this browser only, kept per user, so storage that is full,
// blocked or private just means the Help Center forgets. Logout removes every
// "helpCenter." key (AuthService.logout).

const keyFor = (name) => {
   const userId = AuthService.getUser()?.id;
   return userId ? `helpCenter.${name}.${userId}` : `helpCenter.${name}`;
};

export const readHelpValue = (name, fallback) => {
   try {
      const raw = localStorage.getItem(keyFor(name));
      return raw === null ? fallback : JSON.parse(raw);
   } catch (error) {
      return fallback;
   }
};

export const writeHelpValue = (name, value) => {
   try {
      localStorage.setItem(keyFor(name), JSON.stringify(value));
   } catch (error) {
      // The Help Center works without it.
   }
};
